import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios"
import { AlertTitle, Button, Divider, FormControl, InputLabel, List, ListItem, ListItemText, MenuItem, Select, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { Auth } from "aws-amplify";
import { useTranslation, Trans } from "react-i18next";

import UploadIcon from '@mui/icons-material/Upload';
import DescriptionIcon from '@mui/icons-material/Description';

import SampleWorksheet from "../../../data/SampleWorksheet.xlsx"
import SheetCannotBeReadSolution from "../../../data/SheetCannotBeReadSolution.PNG"
import DeleteStudents from "./DeleteStudents";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="standard" {...props} />;
});

const ExcelUpload = ({adminInfo}) => {

  useEffect(() => {
    if(adminInfo.admin.schools.length === 1) setSchool(adminInfo.admin.schools[0].id)
  }, [adminInfo]);

  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadDisbale, setUploadDisable] = useState(false);
  const [uploadResponse, setUploadResponse] = useState({});
  const [school, setSchool] = useState("");

  const { t } = useTranslation()

  function downloadSample(){
    const link = document.createElement('a');
    link.download = "Student-Sample-Worksheet.xlsx";
    link.href = SampleWorksheet;
    link.click();
  }

  const excelUpload = async (file, adminId, schoolId, testId) => {

    Auth.currentSession()
    .then(async (data) => {
      const jwtToken = data.idToken.jwtToken;

      try {
        const uploadResponse =  await axios.post("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/student-excel-upload", 
          JSON.stringify({
            "testId": testId,
            "schoolId": schoolId,
            "excelFile": file
          }), 
          {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
          }
        });
        // console.log("Upload Response: ",uploadResponse.data)
        if(uploadResponse.data.status === "success") setToastType(["success", t("admin.studentExcelUpload.upload_api_success")])
        else setToastType(["error", t("admin.studentExcelUpload.upload_api_error")])
        setToastOpen(true)
        setUploadResponse(uploadResponse.data)
        setSelectedFile(null)
        setUploadDisable(false)
      }
      catch (error) {
        console.log(error)
        setToastType(["error", t("admin.studentExcelUpload.upload_api_error")])
        setToastOpen(true)
        setUploadResponse({"status": "error", "message": [t("commonItems.error_api_generic")]})
        setUploadDisable(false)
      }
    })
    .catch((err) => console.log(err));
  };

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return
    setToastOpen(false);
  };

  // Helper function for handling file upload
  const handleFileUpload = (e) => {
    setUploadResponse({})
    setToastOpen(true)
    
    if (!school){
      setToastType(["warning", t("admin.studentExcelUpload.error_schoolNotSelected")])
      return
    }

    if (!selectedFile){
      setToastType(["warning", t("admin.studentExcelUpload.error_fileNotSelected")])
      return
    }
    
    if (selectedFile.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
      setToastType(["warning", t("admin.studentExcelUpload.error_notExcelFile")])
      return
    }
    
    if(!adminInfo.test){
      setToastType(["warning", t("commonItems.error_testNotStarted")])
      return
    }

    if(adminInfo.test.status!==0 ? adminInfo.test.status!==1 : false){
      setToastType(["warning", t("admin.studentExcelUpload.error_additionNotAllowed")])
      return
    }

    // if(Number(adminInfo.admin.schools.filter(item => item.id === school)[0].studentCount)!==0){
    //   setToastType(["warning", "For addition of new list of students, please delete existing student list by clicking on \"Students\" from the menu on the left and then clicking \"Delete all entries\"."])
    //   return
    // }

    setToastType(["info", t("admin.studentExcelUpload.info_fileProcessing")]);

    const adminId = adminInfo.admin.adminId;
    // console.log(adminId, schoolId)

    // console.log(selectedFile);
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = () => {
      excelUpload(reader.result, adminId, school, adminInfo.test.testId)
      setUploadDisable(true)
    }
  }

  const handleSchoolChange = (e) => {
    setSchool(e.target.value);
  };

  return (
    <div className="excelUpload" style={{display: "flex", flexDirection: "column", gap: "1rem"}}>
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("admin.studentExcelUpload.title")}
      </h2>
      {false ? 
        <MuiAlert severity="warning" className="uploadInstructions">
          <AlertTitle><b>{t("commonItems.info_featureNotAvailable")}</b></AlertTitle>
        </MuiAlert>
      :
        <>
          {(adminInfo.test && adminInfo.test.superAdminId===24) ?
            <MuiAlert severity="info">
              <AlertTitle><b>{t("admin.studentExcelUpload.info_KVStudentAddition")}</b></AlertTitle>
            </MuiAlert>
          :
            <>
              <MuiAlert severity="info" className="uploadInstructions">
                <AlertTitle><b>{t("admin.studentExcelUpload.instructions_title")}</b></AlertTitle>
                  <Divider/>
                  <List dense={true} sx={{listStyleType: "decimal", listStylePosition: "inside"}}>
                    <ListItem disableGutters>
                      <ListItemText primary={
                        <p style={{color: "#dc3545"}}>
                          <strong>
                              <Trans 
                                i18nKey={"admin.studentExcelUpload.instructions_line1"}
                                components={{
                                  1: <Button 
                                      variant="text" 
                                      color="inherit"
                                      component ={Link}
                                      to="/students" 
                                      sx={{padding: "0", fontWeight: "bold", textTransform: "capitalize", textDecoration: "underline", textUnderlinePosition: "under"}}
                                      >
                                      </Button> 
                                }}
                              />
                          </strong>
                        </p>
                      }/>
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemText primary={
                        <p>
                          <Trans 
                            i18nKey={"admin.studentExcelUpload.instructions_line2"}
                            components={{
                              1: <strong></strong>,
                              2: <Button className="downloadSample" size="small" variant="contained" color="info" onClick={downloadSample} startIcon={<DescriptionIcon />}></Button>
                            }}
                          />
                        </p>
                      }/>
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemText primary={<p><strong>{t("admin.studentExcelUpload.instructions_line3")}</strong></p>}/>
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemText primary={<p><strong>{t("admin.studentExcelUpload.instructions_line4")}</strong></p>}/>
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemText primary={<p><strong>{t("admin.studentExcelUpload.instructions_line5")}</strong></p>}/>
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemText primary={
                        <p><strong>
                          <Trans 
                            i18nKey={"admin.studentExcelUpload.instructions_line6"}
                            components={{
                              1: <Button 
                                    variant="text" 
                                    color="inherit"
                                    component={Link}
                                    to="https://forms.gle/fnU48UpGWWs5zgoT6" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    sx={{padding: "0", fontWeight: "bold", textTransform: "capitalize", textDecoration: "underline", textUnderlinePosition: "under"}}
                                  >
                                  </Button>
                            }}
                          />
                        </strong></p>
                      }/>
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemText primary={<p><strong>{t("admin.studentExcelUpload.instructions_line7")}</strong></p>}/>
                    </ListItem>
                  </List>
              </MuiAlert>
              <div className="upload">
                <FormControl sx={{ m: 1, minWidth: 160 }} size="small">
                  <InputLabel id="schoolFilterLabel">{t("admin.studentExcelUpload.dropdownLabel_school")}</InputLabel>
                  <Select
                    labelId="schoolFilterLabel"
                    id="schoolFilter"
                    value={school}
                    onChange={handleSchoolChange}
                    autoWidth
                    label={t("admin.studentExcelUpload.dropdownLabel_school")}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {/* getting all unique divn values from data */}
                    { adminInfo &&
                      adminInfo.admin.schools.map((item, i) => {
                        return <MenuItem key={i} value={item.id}>{item.name}</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <form className="uploadFile">
                  <Button
                    variant="text"
                    component="label"
                    // startIcon={}
                    style={{
                      textTransform: "capitalize",
                      gap: "1rem",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    <label
                      className="form-label"
                      htmlFor="customFile"
                      style={{ display: "flex", alignItems: "center", gap: "1rem", cursor: "pointer", whiteSpace: "break-spaces" }}
                    >
                      <UploadIcon />
                      {selectedFile ? selectedFile.name : 
                        <div>
                          <Trans 
                            i18nKey={"admin.studentExcelUpload.uploadFileLabel"}
                            components={{
                              1: <Button 
                                    variant="text" 
                                    component ={Link}
                                    target="_blank"
                                    to="/privacy-policy" 
                                    sx={{padding: "0", fontWeight: "bold", textTransform: "capitalize", textDecoration: "underline", textUnderlinePosition: "under"}}
                                  >
                                  </Button>
                            }}
                          />
                        </div>
                      }
                    </label>
                    <input
                      hidden
                      type="file"
                      accept=".xlsx"
                      onChange={(e) => {setSelectedFile(e.target.files[0]); e.target.value = ""}}
                      className="form-control btn"
                      id="customFile"
                    />
                  </Button>
                  <Button
                    disabled={uploadDisbale}
                    onClick={handleFileUpload}
                    variant="contained"
                    component="label"
                    className="btn"
                  >
                    {t("admin.studentExcelUpload.buttonLabel_submit")}
                  </Button>
                </form>
              </div>
              <Snackbar open={toastOpen} autoHideDuration={5000} onClose={handleToastClose}>
                <Alert onClose={handleToastClose} severity={toastType[0]} sx={{ width: '100%' }}>
                {toastType[1]}
                </Alert>
              </Snackbar>
              {Object.keys(uploadResponse).length!==0 && 
                <MuiAlert severity={uploadResponse.status} className="uploadStatus">
                  <AlertTitle><b>Upload {uploadResponse.status === "success" ? "Success" : "Error" }:</b></AlertTitle>
                    <Divider/>
                    <List dense={true} sx={{listStyleType: "decimal", listStylePosition: "inside"}}>
                      {uploadResponse.message.map((m, i) => {
                        if(m.includes("—")){
                          let splitM = m.split("—")
                          return (
                            <ListItem key={i} disableGutters>
                              <ListItemText primary={<p><strong>{splitM[0]}</strong> — {splitM[1]}</p>}/>
                            </ListItem>
                          )
                        }
                        else if(m.includes("[list]")){
                          let splitM = m.split("[list]")
                          return (
                            <ListItem key={i}>
                              <ListItemText primary={<p>{splitM[1]}</p>}/>
                            </ListItem>
                          )
                        }
                        else if(m.includes("[Screenshot]")){
                          let splitM = m.split("[Screenshot]")
                          return (
                            <ListItem key={i} disableGutters>
                              <ListItemText primary={
                                <>
                                  <p><strong>{splitM[0]}</strong></p>
                                  <img src={SheetCannotBeReadSolution} alt="Sheet Cannot be Read Solution"/>
                                </>
                              }/>
                            </ListItem>
                          )
                        }
                        else if(m.includes("Delete all entries")){
                          return (
                            <ListItem key={i} disableGutters>
                              <ListItemText primary={
                                <>
                                  <p><strong>{m}</strong></p>
                                  {school && <DeleteStudents adminInfo={adminInfo} schoolId={school}/>}
                                </>
                              }/>
                            </ListItem>
                          )
                        }
                        else{
                          return (
                            <ListItem key={i} disableGutters>
                              <ListItemText primary={<p><strong>{m}</strong></p>}/>
                            </ListItem>
                          )
                        }
                      })}
                    </List>
                </MuiAlert>
              }
            </>
          }
        </>
      }
    </div>
  );
};

export default ExcelUpload;
